// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hide-ads-container[data-v-79393618] {\n    width: 100%;\n    text-align: left;\n}\n.hide-ads-button[data-v-79393618] {\n    position: absolute;\n    font-size: 10px;\n    background: #FBA500;\n    color: white;\n    font-weight: bold;\n    border-top-right-radius: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
